define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Trademark = void 0;
    class Trademark {
        constructor(data) {
            this.MakeFileLabel = (type) => {
                let isVector = ['ai', 'eps', 'svg'].filter(vector => type === vector).length > 0;
                return `${type.toUpperCase()}, ${isVector ? 'Vector' : 'Raster'} Image`;
            };
            ko.mapping.fromJS(data, {}, this);
            this.HasPreview = ko.computed(() => this.ThumbImagePath() !== '');
            this.FileTypeLabel = ko.computed(() => this.MakeFileLabel(this.FileType()));
            this.TypeId = ko.computed(() => this.Type().toLowerCase().replace(' ', '-'));
        }
    }
    exports.Trademark = Trademark;
});
//# sourceMappingURL=Trademark.js.map